<template>
  <div class="home">
    <HeaderView></HeaderView>
    <div class="banner" @mouseleave="startAutoPlay">
      <div class="banner-item" v-for="(item, index) in bannerList" :key="index" v-show="currentIndex === index">
        <img :src="item.img" alt="" />
        <div class="banner-text">
          <h1 v-html="item.title"></h1>
          <p v-html="item.subtitle"></p>
          <button class="explore-btn">
            探索更多<span class="arrow"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg></span>
          </button>
        </div>
      </div>
      <button class="arrow-btn left" @click="prevSlide">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <button class="arrow-btn right" @click="nextSlide">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <!-- <div class="dots">
        <span v-for="(item, index) in banners" :key="index" :class="{active: currentIndex === index}" @click="goToSlide(index)"></span>
      </div> -->
      <div class="progress-circle">
        <svg width="70" height="70" viewBox="0 0 80 80" style="margin: auto; display: block">
          <circle cx="40" cy="40" r="30" fill="none" stroke="#fff" stroke-width="2" class="progress-bg" />
          <circle cx="40" cy="40" r="30" fill="none" stroke="#fff" stroke-width="2" class="progress-bar"
            :stroke-dasharray="circumference" :stroke-dashoffset="circumference - (circumference * progress) / 100
              " transform="rotate(-90 40 40)" />
        </svg>
      </div>
    </div>

    <section class="section1">
      <div class="section-container">
        <div class="section-bg1"></div>
        <div class="section-bg2"></div>

        <div class="section-title">
          <div class="title-shadow">ABOUT</div>
          <h2>关于弗鲁微</h2>
        </div>
        <p class="section-desc">
          {{ indexData.h_about }}
        </p>

        <!-- pc端显示部分 -->
        <div class="section1-content">
          <div v-for="(item, index) in aboutList" :key="item.id" class="s1-card"
            :class="{ 's1-card-active': activeIndex === index }" @mouseenter="setActive(index)">
            <div class="s1-card-text">
              <h3>{{ item.title }}</h3>
              <p>{{ item.brief }}</p>
              <!-- <button class="explore-btn2">
                探索更多<span class="arrow2"
                  ><svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 18L15 12L9 6"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    /></svg></span>
              </button> -->
            </div>
            <div class="s1-card-img">
              <img :src="item.image" alt="" />
            </div>
          </div>
        </div>

        <!-- 移动端展示部分 ----------->
        <button class="explore-btn" @click="showAboutMobile = !showAboutMobile"
          style="margin: 0 auto 20px; display: block">
          {{ showAboutMobile ? "收起" : "展开"
          }}<span class="arrow"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg></span>
        </button>
        <div class="section1-content-mobile" v-show="showAboutMobile">
          <div class="swiper-wrapper-mobile" :style="{ transform: 'translateX(' + -activeIndex * 100 + 'vw)' }">
            <div v-for="(item, index) in aboutList" :key="item.id" class="s1-card-mobile">
              <div class="s1-card-text">
                <h3>{{ item.title }}</h3>
                <p>{{ item.brief }}</p>
                <!-- <button class="explore-btn2">
                  探索更多<span class="arrow2"
                    ><svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 18L15 12L9 6"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      /></svg></span>
                </button> -->
              </div>
              <div class="s1-card-img">
                <img :src="item.image" alt="" />
              </div>
            </div>
          </div>
          <div class="swiper-dots-mobile">
            <span v-for="(item, index) in aboutList" :key="index" :class="{ active: activeIndex === index }"
              @click="setActive(index)"></span>
          </div>
          <button class="swiper-arrow-mobile left" @click="prevMobileCard">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
          <button class="swiper-arrow-mobile right" @click="nextMobileCard">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
        </div>
        <!-- ------------ -->
      </div>
    </section>

    <section class="section2">
      <div class="section-container">
        <div class="section-title">
          <div class="title-shadow">PRODUCT</div>
          <h2>产品介绍</h2>
        </div>
        <p class="section-desc">{{ indexData.h_product }}</p>

        <div class="product-content">
          <div class="product-item" v-for="item in products" :key="item.id" @click="goToProducts(item.id)">
            <img :src="item.image" alt="" />
            <div class="product-item-text">
              <h3>{{ item.name }}</h3>
              <p>{{ item.nickname }}</p>
            </div>
            <button class="explore-more-btn" @click="goToProducts(item.id)">
              探索更多<span class="arrow-white"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg></span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="section3">
      <div class="section-container">
        <div class="section-title">
          <div class="title-shadow">R&D CASE</div>
          <h2>研发案例</h2>
        </div>
        <div class="step-box">
          <div>
            <div class="step-container">
              <div v-for="(step, idx) in stepTabs" :key="step.name" class="step-item"
                :class="{ active: currentStep === idx }" @click="switchStep(idx)">
                {{ step.name }}
              </div>
            </div>
            <div style="display: inline-block">
              <router-link to="/cases#engineering" class="step-item2">
                工程
              </router-link>
            </div>
          </div>

          <Swiper :key="currentStep" :slides-per-view="1" :space-between="20" :loop="true"
            :autoplay="{ delay: 30000, disableOnInteraction: false }" :modules="modules" :navigation="{
              prevEl: '.swiper-button-prev2',
              nextEl: '.swiper-button-next2',
            }" :pagination="{ clickable: true }" class="auto-swiper">
            <SwiperSlide v-for="(slide, idx) in caseSlides" :key="idx">
              <div class="s3-content">
                <div class="s3-list">
                  <ul>
                    <li v-for="(item, itemIdx) in slide.items" :key="itemIdx">
                      <div class="s3-content-text">
                        <h3>{{ item.title }}</h3>
                        <p>{{ item.desc }}</p>
                      </div>
                      <router-link :to="{ name: 'caseDetail', params: { id: item.id } }" class="s3-arrow">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M9 18L15 12L9 6" />
                        </svg>
                      </router-link>
                    </li>
                  </ul>
                </div>
                <div class="s3-img">
                  <img :src="slide.image" alt="" />
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </section>

    <section class="section4">
      <div class="s4top-box">
        <div class="section-title2">
          <div class="title-shadow2">NEWS</div>
          <h2>新闻中心</h2>
        </div>
        <div class="news-btns">
          <div class="news-item" :class="{ active: currentNewsTab === index }" v-for="(item, index) in newsList"
            :key="index" @click="switchNewsTab(index)">
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="news-content">
        <template v-if="newsList[currentNewsTab] && newsList[currentNewsTab].list">
          <!-- :class="index === 0 ? 'news-card' : 'news-card2'"
            :style="index === 0 ? `background-image:url('${item.image}')` : ''" -->
          <div v-for="(item, index) in newsList[currentNewsTab].list" :key="index" class="news-card2" @click="
            $router.push({ name: 'newsDetail', params: { id: item.id } })
            " style="cursor: pointer">
            <template v-if="index === 0">
              <img :src="item.image" alt="" />
              <div class="news-content-text2">
                <div class="news-date2">
                  <span>{{
                    item.create_time
                      ? item.create_time.split("-")[1] +
                      "/" +
                      item.create_time.split("-")[2]
                      : ""
                  }}</span>/{{ item.create_time ? item.create_time.split("-")[0] : "" }}
                </div>

                <h3>{{ item.titile }}</h3>
                <p>{{ item.brief }}</p>
              </div>
              <!-- <div class="news-content-btn">
                <a href="" class="s4-arrow">
                  <svg
                    width="35"
                    height="35"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M9 18L15 12L9 6" />
                  </svg>
                </a>
              </div> -->
            </template>
            <template v-else>
              <img :src="item.image" alt="" />
              <div class="news-content-text2">
                <div class="news-date2">
                  <span>{{
                    item.create_time
                      ? item.create_time.split("-")[1] +
                      "/" +
                      item.create_time.split("-")[2]
                      : ""
                  }}</span>/{{ item.create_time ? item.create_time.split("-")[0] : "" }}
                </div>
                <h3>{{ item.titile }}</h3>
                <p>{{ item.brief }}</p>
              </div>
            </template>
          </div>
        </template>
      </div>
    </section>

    <section class="section5">
      <div class="section-title3">
        <div class="title-shadow title-shadow3">SALES</div>
        <h2>全国销售网络</h2>
      </div>
      <p class="section-desc">{{ indexData.h_quanqiu }}</p>
      <img src="/imgs/index/images/indexmap_03.png" alt="" />
    </section>
    <section class="section6">
      <div class="section-title3">
        <div class="title-shadow title-shadow3">PARTNER</div>
        <h2>合作伙伴</h2>
      </div>

      <!-- <img src="/imgs/index/images/partner_10.png" alt=""> -->
      <div class="fengc" v-if="partnerList && partnerList.length > 1">
        <div class="hex-grid hex-grid1">
          <div class="hex-item qblue"></div>
          <div class="hex-item qblue"></div>
        </div>
        <div class="hex-grid hex-grid2">
          <div class="hex-item"></div>
          <div class="hex-item dblue"></div>
          <div class="hex-item">
            <img :src="partnerList[0].image" alt="" />
          </div>
          <div class="hex-item qblue"></div>
        </div>
        <div class="hex-grid hex-grid3">
          <div class="hex-item">
            <img :src="partnerList[1].image" alt="" />
          </div>
          <div class="hex-item">
            <img :src="partnerList[2].image" alt="" />
          </div>
          <div class="hex-item dblue"></div>
        </div>
        <div class="hex-grid hex-grid4">
          <div class="hex-item">
            <img :src="partnerList[3].image" alt="" />
          </div>
          <div class="hex-item">
            <img :src="partnerList[4].image" alt="" />
          </div>
          <div class="hex-item">
            <img :src="partnerList[5].image" alt="" />
          </div>
          <div class="hex-item">
            <img :src="partnerList[6].image" alt="" />
          </div>
        </div>
        <div class="hex-grid hex-grid5">
          <div class="hex-item"></div>
          <div class="hex-item qblue"></div>
          <div class="hex-item">
            <img :src="partnerList[7].image" alt="" />
          </div>
        </div>
        <div class="hex-grid hex-grid6">
          <div class="hex-item">
            <img :src="partnerList[8].image" alt="" />
          </div>
          <div class="hex-item"></div>
          <div class="hex-item"></div>
          <div class="hex-item qblue"></div>
        </div>
        <div class="hex-center">
          <!-- <img src="/imgs/index/images/images/partner-center_06.png" alt=""> -->
          <div class="hex-center-text">
            <span>19+</span>
            <p>累计服务客户</p>
          </div>
        </div>
        <div class="hex-grid hex-grid7">
          <div class="hex-item"></div>
          <div class="hex-item qblue"></div>
          <div class="hex-item"></div>
        </div>
        <div class="hex-grid hex-grid8">
          <div class="hex-item">
            <img :src="partnerList[9].image" alt="" />
          </div>
          <div class="hex-item">
            <img :src="partnerList[10].image" alt="" />
          </div>
          <div class="hex-item">
            <img :src="partnerList[11].image" alt="" />
          </div>
          <div class="hex-item dblue"></div>
        </div>
        <div class="hex-grid hex-grid9">
          <div class="hex-item">
            <img :src="partnerList[12].image" alt="" />
          </div>
          <div class="hex-item">
            <img :src="partnerList[13].image" alt="" />
          </div>
          <div class="hex-item">
            <img :src="partnerList[14].image" alt="" />
          </div>
        </div>
        <div class="hex-grid hex-grid10">
          <div class="hex-item">
            <img :src="partnerList[15].image" alt="" />
          </div>
          <div class="hex-item dblue"></div>
          <div class="hex-item qblue"></div>
          <div class="hex-item"></div>
        </div>
      </div>

      <!-- 移动端回到顶部按钮 -->
      <button v-show="showBackToTop" class="back-to-top" @click="scrollToTop">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 15L12 9L6 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </section>

    <FooterView></FooterView>
  </div>
</template>

<script>
import apiServe from "../services/index.js";
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

export default {
  name: "HomeView",
  components: {
    HeaderView,
    FooterView,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      modules: [Pagination, Autoplay, Navigation],
      currentIndex: 0,
      timer: null,
      progress: 0,
      progressTimer: null,
      banners: [],
      bannerList: [],
      // steps: [
      //   {
      //     name: "研发",
      //     slides: [
      //       {
      //         img: "/imgs/index/images/case_03.png",
      //         items: [
      //           {
      //             title: "硝化——2,4-二硝基氯苯",
      //             desc: "2,4-二氯硝基苯是一种重要的有机合成中间体，应用领域较为广泛，是制造硫化黑等多种染料的重要中间体......",
      //           },
      //           {
      //             title: "氯化——2-氯丙酸乙酯（EtSCP）",
      //             desc: "主要应用在农药、医药和香料领域，下游产品......",
      //           },
      //           {
      //             title: "氯化——烟嘧磺胺（烟嘧磺隆中间体）",
      //             desc: "主要用于合成除草剂烟嘧磺隆，烟嘧磺隆是一种选择性内吸传导型......",
      //           },
      //         ],
      //       },
      //       {
      //         img: "/imgs/index/images/case_03.png",
      //         items: [
      //           {
      //             title: "硝化——2,4-二硝基氯苯",
      //             desc: "2,4-二氯硝基苯是一种重要的有机合成中间体，应用领域较为广泛，是制造硫化黑等多种染料的重要中间体......",
      //           },
      //           {
      //             title: "氯化——2-氯丙酸乙酯（EtSCP）",
      //             desc: "主要应用在农药、医药和香料领域，下游产品......",
      //           },
      //           {
      //             title: "氯化——烟嘧磺胺（烟嘧磺隆中间体）",
      //             desc: "主要用于合成除草剂烟嘧磺隆，烟嘧磺隆是一种选择性内吸传导型......",
      //           },
      //         ],
      //       },
      //     ],
      //   },
      // ],
      currentStep: 0,
      caseSlides: [],
      activeIndex: 0,
      news: [],
      currentNewsTab: 0,
      newsList: [],
      indexData: {},
      products: [],
      aboutList: [],
      caseApiData: [],
      cases: [],
      partnerList: [],
      showBackToTop: false, // 控制回到顶部按钮显示
      showAboutMobile: false, // 控制移动端关于展开收起
    };
  },
  mounted() {
    this.fetchData();

    this.startAutoPlay();
    this.switchStep(0);
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    this.pauseAutoPlay();
    this.clearProgress();
    window.removeEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    this.pauseAutoPlay();
    this.clearProgress();
    window.removeEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    this.pauseAutoPlay();
    this.clearProgress();
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    circumference() {
      return 2 * Math.PI * 30;
    },
    stepTabs() {
      const apiSteps =
        this.caseApiData.length &&
          this.caseApiData[0] &&
          this.caseApiData[0].list
          ? this.caseApiData[0].list.map((item) => ({ name: item.nickname }))
          : [];
      // 研发tab名称使用cases数据第一条的title，如果没有则使用默认"研发"
      // const firstCaseTitle = this.cases && this.cases.length > 0 ? this.cases[0].name : "研发";
      // return [{ name: firstCaseTitle }, ...apiSteps];
      return [{ name: "研发" }, ...apiSteps];
    },
  },
  methods: {
    goToProducts(categoryId) {
      // 根据当前products列表动态生成id→tab映射
      const tabMap = this.products.reduce((map, product, index) => {
        const tabs = ["dynamic", "microchannel", "microbubble", "mixer"];
        map[product.id] = tabs[index] || "dynamic";
        return map;
      }, {});
      const tab = tabMap[categoryId] || "dynamic";
      this.$router.push({ name: "products", query: { tab: tab } });
    },
    // 监听滚动，控制回到顶部按钮显示
    handleScroll() {
      this.showBackToTop = window.scrollY > 300;
    },
    // 平滑滚动到顶部
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    fetchData() {
      apiServe.getIndexData({}, "get").then((res) => {
        console.log(res, "我是查询数据");
        this.indexData = res.data || {};
        // 处理banner数据
        if (res.data.banner && res.data.banner.length > 0) {
          this.bannerList = res.data.banner.map((item) => ({
            img: item.image,
            title: item.title,
            subtitle: item.title_en || item.brief || "",
          }));
        }

        const news = res.data.news || [];
        this.newsList = news;

        // 处理产品数据
        const products = res.data.product || [];
        this.products = products;

        // 处理about数据
        const about = res.data.about || [];
        this.aboutList = about;

        // 保存接口返回的case数据
        this.caseApiData = res.data.case || [];
        // 保存接口返回的cases数据（研发案例真实数据）
        this.cases = res.data.cases || [];
        // 保存接口返回的partner数据
        this.partnerList = res.data.partner || [];
        // 数据拿到后主动触发一次switchStep(0)，确保默认展示第一个tab内容
        this.$nextTick(() => {
          this.switchStep(0);
        });
      });
    },
    switchNewsTab(index) {
      this.currentNewsTab = index;
    },
    setActive(index) {
      this.activeIndex = index;
    },
    prevMobileCard() {
      if (this.activeIndex > 0) this.activeIndex--;
      else this.activeIndex = this.aboutList.length - 1;
    },
    nextMobileCard() {
      if (this.activeIndex < this.aboutList.length - 1) this.activeIndex++;
      else this.activeIndex = 0;
    },
    startAutoPlay() {
      this.pauseAutoPlay();
      this.resetProgress();
      this.timer = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    resetProgress() {
      this.progress = 0;
      if (this.progressTimer) clearInterval(this.progressTimer);
      this.progressTimer = setInterval(() => {
        this.progress += 2; // 5s/50步≈100ms一步
        if (this.progress >= 100) {
          clearInterval(this.progressTimer);
        }
      }, 100);
    },
    clearProgress() {
      if (this.progressTimer) {
        clearInterval(this.progressTimer);
        this.progressTimer = null;
      }
    },
    pauseAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.bannerList.length;
      this.startAutoPlay();
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.bannerList.length) %
        this.bannerList.length;
      this.startAutoPlay();
    },
    goToSlide(index) {
      this.currentIndex = index;
      this.startAutoPlay();
    },
    async switchStep(idx) {
      this.currentStep = idx;
      if (idx === 0) {
        // 研发阶段使用接口返回的cases数据
        if (this.cases && this.cases.length > 0) {
          // 将cases数据转换为slides格式，每页最多3条
          const total = this.cases.length;
          const page1 = this.cases.slice(0, 3);
          const page2 = total > 3 ? this.cases.slice(3, 6) : [];
          const slides = [];
          if (page1.length) {
            slides.push({
              image: page1[0].image || "/imgs/index/images/case_03.png",
              items: page1.map((item) => ({
                title: item.title,
                desc: item.brief,
                id: item.id,
              })),
            });
          }
          if (page2.length) {
            slides.push({
              image: page2[0].image || "/imgs/index/images/case_03.png",
              items: page2.map((item) => ({
                title: item.title,
                desc: item.brief,
                id: item.id,
              })),
            });
          }
          this.caseSlides = slides;
        } else {
          this.caseSlides = [];
        }
      } else {
        // 其他阶段使用接口数据构造slides
        const apiCase = this.caseApiData[0];
        if (apiCase && apiCase.list && apiCase.list.length > idx - 1) {
          const targetCase = apiCase.list[idx - 1];
          if (targetCase && targetCase.list) {
            // 将接口数据拆成两页，每页最多3条
            const total = targetCase.list.length;
            const page1 = targetCase.list.slice(0, 3);
            const page2 = total > 3 ? targetCase.list.slice(3) : [];
            const slides = [];
            if (page1.length) {
              slides.push({
                image: page1[0].image || "/imgs/index/images/case_03.png",
                items: page1.map((item) => ({
                  title: item.title,
                  desc: item.brief,
                  id: item.id,
                  image: item.image,
                })),
              });
            }
            if (page2.length) {
              slides.push({
                image: page2[0].image || "/imgs/index/images/case_03.png",
                items: page2.map((item) => ({
                  title: item.title,
                  desc: item.brief,
                  id: item.id,
                  image: item.image,
                })),
              });
            }
            this.caseSlides = slides;
          } else {
            this.caseSlides = [];
          }
        } else {
          this.caseSlides = [];
        }
      }
      await this.$nextTick();
    },
  },
  // npm install vue-meta@^2.4.0 --save
  metaInfo() {
    return {
      title: '山东弗鲁微科技 - 连续流微反应器装备制造商 | 微化工技术解决方案',
      meta: [
        { name: 'keywords', content: '微反应器，连续流技术，连续化，微通道反应器，动态管式反应器，微混合器，微气泡，连续结晶，格氏反应器，微化工设备，连续流装备，连续流工艺优化，连续反应，工艺包开发，硝化反应，氯化反应，加氢反应，弗鲁微科技' },
        { name: 'description', content: '山东弗鲁微科技有限公司是专业的连续流装备制造商，提供微通道反应器、动态管式反应器、微气泡反应器、连续结晶器、格氏反应器等系列产品及硝化、氯化、氧化、重氮化、加氢、丁基锂、格氏等危险工艺的连续流解决方案。从实验室研发到工业化撬装放大，为您提供安全、高效、精准的微化工技术一站式服务。' }
      ]
    };
  }
};
</script>

<style scoped>
.fengc {
  max-width: 1460px;
  width: 85%;
  height: 660px;
  margin: 2rem auto;
  position: relative;
}

.hex-grid {
  width: 11%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  position: absolute;
}

.hex-center {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 10;
  pointer-events: none;
}

.hex-center-text {
  background-image: url("/public/imgs/index/images/images/partner-center_06.png");
  background-size: cover;
  background-position: center;
  width: 25%;
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 0.5rem;
  color: #fff;
  animation: centerPulse 2s ease-in-out infinite;
}

@keyframes centerPulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.03);
  }
}

.hex-center-text span {
  font-family: "Source_Han_Sans_SC_Regular";
  font-size: 5rem;
  font-weight: bold;
}

.hex-center-text p {
  font-size: 1.6rem;
}

.hex-center img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.hex-grid1 {
  top: 62%;
  left: 5%;
  transform: translate(-50%, -50%);
}

.hex-grid2 {
  top: 50%;
  left: 14%;
  transform: translate(-50%, -50%);
}

.hex-grid3 {
  top: 62%;
  left: 23%;
  transform: translate(-50%, -50%);
}

.hex-grid4 {
  top: 50%;
  left: 32%;
  transform: translate(-50%, -50%);
}

.hex-grid5 {
  top: 62%;
  left: 41%;
  transform: translate(-50%, -50%);
}

.hex-grid6 {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.hex-grid7 {
  top: 62%;
  left: 59%;
  transform: translate(-50%, -50%);
}

.hex-grid8 {
  top: 50%;
  left: 68%;
  transform: translate(-50%, -50%);
}

.hex-grid9 {
  top: 62%;
  left: 77%;
  transform: translate(-50%, -50%);
}

.hex-grid10 {
  top: 50%;
  right: 3%;
  transform: translate(-50%, -50%);
}

.hex-item {
  width: 100%;
  height: 145px;
  /* background: linear-gradient(135deg, #2c5aa0 0%, #1e3d6f 100%); */
  background: #eef3f8;
  clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
  position: relative;
  transition: transform 0.6s ease, box-shadow 0.3s ease;
  box-shadow: 0 8px 25px rgba(44, 90, 160, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  transform-style: preserve-3d;
  cursor: pointer;
  backface-visibility: hidden;
}

.hex-item {
  transition: transform 0.8s cubic-bezier(0.25, 0.1, 0.25, 1) 0s;
}

.hex-item:hover {
  transform: rotateY(360deg) scale(1.05);
  transition-delay: 150ms;
}

.hex-item img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.dblue {
  background: #73bded;
}

.qblue {
  background: #e1f4ff;
}

.hex-item::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  background: rgba(255, 255, 255, 0.1);
  clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
  z-index: -1;
}

section {
  width: 100%;
  /* height: 99vh; */
  height: 1100px;
  position: relative;
}

.section-container {
  margin: 0 auto;
  width: 1560px;
  width: 90%;
  padding: 5rem 5rem;
}

@media (max-width: 1500px) {
  .section-container {
    padding: 5rem 1rem;
  }
}

.section1 {
  background-color: #ebf4ff;
}

.section2 {
  position: relative;
  z-index: 0;
  background-image: url("/public/imgs/index/images/chanp-bg_02.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.section5 {
  width: 100%;
  /* height: 99vh; */
  /* height: 880px; */
  height: auto;
  /* background-image: url("/public/imgs/index/images/indexmap_03.png"); */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 5rem;
}

.section5 img {
  width: 100%;
  height: auto;
  display: block;
  /* margin-top: -17.5rem; */
  /* width: 100%;
  height: auto;
  display: block;
  margin-top: -13.5rem; */
}

.section6 {
  width: 100%;
  height: 880px;
  background: #e1edf9;
  padding-top: 8rem;
}

.section6>img {
  /* width: 600px; */
  height: auto;
  display: block;
  margin: 2rem auto;
}

.section-title {
  font-size: 2.2rem;
  text-align: center;
  margin: 5rem auto 2rem;
  position: relative;
}

.section-title2 {
  font-size: 2.2rem;
  text-align: center;
  position: relative;
}

.section-title3 {
  font-size: 2.2rem;
  text-align: center;
  position: relative;
  z-index: 1;
  padding-top: 0rem;
}

.section-title h2 {
  font-weight: 400;
  position: relative;
  z-index: 1;
}

.section-title2 h2 {
  font-weight: 400;
  position: relative;
  /* left: -65px; */
  z-index: 1;
}

.title-shadow {
  position: absolute;
  font-size: 7.5rem;
  font-weight: 600;
  top: 100%;
  left: 50%;
  transform: translate(-50%, -100%);
  color: rgba(0, 0, 0, 0.06);
}

.title-shadow2 {
  position: absolute;
  font-size: 7.5rem;
  font-weight: 600;
  top: 100%;
  left: 80%;
  transform: translate(-50%, -100%);
  color: #eef7ff;
  z-index: 1;
}

.title-shadow3 {
  color: #eef7ff;
  opacity: 0.9;
  z-index: -1;
}

@media (max-width: 1350px) {
  .title-shadow {
    font-size: 5.5rem;
  }

  .title-shadow2 {
    font-size: 5.5rem;
  }
}

.section-desc {
  width: 85%;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.5;
  margin: 1rem auto 5rem;
  position: relative;
  z-index: 1;
}

.section1-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.section4 {
  max-width: 1500px;
  width: 95%;
  height: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5rem;
}

.s4top-box {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.news-btns {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.news-item {
  width: 140px;
  height: 30px;
  font-size: 1.1rem;
  text-align: center;
  line-height: 30px;
  background: #f1f1f1;
  border-radius: 15px;
  padding: 0.5rem 0.5rem;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: background 0.3s ease, color 0.2s ease;
}

.news-item:hover {
  background: linear-gradient(to right, #0876c1, #1e9eef);
  color: #fff;
}

.news-item.active {
  background: linear-gradient(to right, #0876c1, #1e9eef);
  color: #fff;
}

.news-content {
  width: 100%;
  /* margin: 0 auto; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* gap: 1rem; */
}

.news-content>div {
  /* width: 440px; */
  width: 30%;
  height: 610px;
  background: #fff;
  border-radius: 30px;
  /* padding: 3rem 2.5rem; */
  /* box-shadow: 0 2px 8px rgba(0,0,0,0.06); */
  /* border: 1px solid #000; */
  transition: background 0.3s ease;
  cursor: pointer;
}

/* .news-content > div:first-child {
  background-size: cover;
  background-position: center;
  width: 36%;
  position: relative;
} */
/* news-card hover 蓝色蒙版，不遮挡按钮 */
.news-card {
  position: relative;
  overflow: hidden;
  border-radius: 0 0 0 30px;
}

.news-card2 {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 2rem;
  position: relative;
}

.news-card2>img {
  width: 100%;
  height: 350px;
  position: relative;
  z-index: 0;
  border-radius: 25px;
  object-fit: cover;
  object-position: center;
}

.news-card2::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 350px;
  background: linear-gradient(to top,
      rgba(0, 102, 255, 0.5) 0%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(0, 102, 255, 0.5) 100%);
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 1;
  border-radius: 25px;
}

@media (max-width: 1350px) {
  .news-card2>img {
    height: 300px;
  }

  .news-card2::before {
    height: 300px;
  }
}

.news-card2:hover::before {
  opacity: 1;
}

.news-content-text2 {
  position: relative;
  z-index: 2;
}

.news-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(to top,
      rgba(0, 102, 255, 0.5) 0%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(0, 102, 255, 0.5) 100%);
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 1;
}

.news-card:hover::before {
  opacity: 1;
}

.news-content-btn {
  z-index: 1;
}

.news-card>* {
  z-index: 1;
}

.news-date1 {
  position: absolute;
  top: 2rem;
  left: 2rem;
  font-size: 1.5rem;
  font-weight: 400;
  color: #fff;
}

.news-date1>span {
  font-size: 2.3rem;
  font-weight: 500;
}

.news-date2 {
  font-size: 1.5rem;
  font-weight: 400;
  margin-bottom: 1.5rem;
}

.news-date2>span {
  font-size: 2.3rem;
  font-weight: 500;
}

.news-content-text1 {
  position: absolute;
  top: 80%;
  left: 1rem;
  font-size: 1.5rem;
  color: #fff;
}

.news-content-text2 {
  padding: 0rem 1.5rem;
}

.news-content-text1>h3 {
  font-size: 1.5rem;
  font-weight: 300;
}

.news-content-text2>h3 {
  font-weight: 300;
  font-size: 1.4rem;
  margin-bottom: 0.5rem;
}

.news-content-text1>p {
  font-family: "HarmonyOS_Sans_SC_Light";
  font-size: 1.4rem;
}

.news-content-text2>p {
  font-family: "HarmonyOS_Sans_SC_Light";
  font-size: 1rem;
}

.s3-content {
  width: 1500px;
  max-width: 100%;
  margin: 5rem auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6rem;
}

.auto-swiper {
  max-width: 100%;
  overflow: hidden;
}

.s3-list {
  width: 65%;
}

.s3-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
  /* display: flex; */
  /* flex-direction: column;
  gap: 1.2rem; */
}

.s3-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  padding: 3rem 2.5rem;
  /* box-shadow: 0 2px 8px rgba(0,0,0,0.06); */
  transition: background 0.3s ease;
  position: relative;
}

.s3-list li::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 90%;
  height: 1px;
  background-color: #acaaaa;
  transition: opacity 0.3s ease;
}

.s3-list li:hover::after {
  opacity: 0;
}

.s3-list li:hover {
  background: #e7f5ff;
}

.s3-list li:hover .s3-content-text h3 {
  color: #1692e5;
}

.s3-list li:hover .s3-content-text p {
  color: #000;
}

.s3-list li:hover .s3-arrow {
  background: #1692e5;
}

.s3-list li:hover .s3-arrow svg {
  stroke: #fff;
}

.s3-list li h3,
.s3-list li p,
.s3-list li .s3-arrow,
.s3-list li .s3-arrow svg {
  transition: color 0.3s ease, background 0.3s ease, stroke 0.3s ease;
}

.s3-content-text h3 {
  margin: 0 0 0.2rem;
  font-size: 2.1rem;
  font-weight: 400;
}

.s3-content-text {
  width: 90%;
  /* max-width: 600px; */
}

.s3-content-text p {
  margin: 0;
  font-size: 1rem;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
}

.s3-arrow {
  position: relative;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f0f0f0;
  transition: background 0.3s ease;
}

.s4-arrow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  color: #f0f0f0;
  background: #0066cc;
  transition: background 0.3s ease;
}

.news-content-btn {
  background: #fff;
  padding: 2.5rem;
  position: absolute;
  top: 93.6%;
  left: 93.2%;
  border-radius: 30px 0px 0px 0px;
  transform: translate(-50%, -50%);
}

.s3-img img {
  /* width: 100%; */
  height: auto;
  max-width: 520px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

@media (max-width: 768px) {
  .s3-content {
    /* flex-direction: column; */
    margin: 0 auto;
    gap: 0rem;
    justify-content: space-between;
  }

  .s3-list ul {
    gap: 0.8rem;
  }

  .s3-list {
    width: 60%;
  }

  .s3-content-text {
    width: 75%;
  }

  .s3-list li {
    padding: 0.8rem 1rem;
  }

  .s3-content-text h3 {
    font-size: 0.8rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .s3-content-text p {
    font-size: 0.6rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .s3-img img {
    max-width: 100%;
  }
}

.step-box {
  width: 95%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.step-container {
  display: inline-flex;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 25px;
  padding: 0;
  overflow: hidden;
}

.step-item {
  padding: 8px 25px;
  font-size: 17px;
  color: #333;
  position: relative;
  border-radius: 25px;
  cursor: pointer;
}

.step-item2 {
  padding: 8px 25px;
  font-size: 17px;
  color: #333;
  position: relative;
  border-radius: 25px;
  cursor: pointer;
  border: 1px solid #808181;
  margin-left: 1rem;
}

.step-item.active {
  background-color: #0066cc;
  color: #fff;
}

.step-item.active::after {
  content: ">";
  margin-left: 8px;
}

.s1-card {
  height: 510px;
  background-color: #ffffff;
  border-radius: 35px;
  padding: 2rem;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  background-image: url("/public/imgs/index/images/section1itembg_03.png");
  background-size: 101% 101%;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 75px;
  transition: width 0.4s ease;
}

.s1-card-active {
  width: 800px;
  border-radius: 5%;
}

.s1-card-text {
  width: 70%;
  padding: 2rem 2rem 2rem 1rem;
  opacity: 0;
  transition: opacity 0.01s ease 0.01s;
}

.s1-card-text h3 {
  margin: 0 0 0.2rem;
  font-size: 2.1rem;
  font-weight: 400;
}

.s1-card-text p {
  font-family: "HarmonyOS_Sans_SC_Light";
  margin: 3rem 0;
  font-size: 1.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.s1-card-active .s1-card-text {
  opacity: 1;
}

.s1-card-img img {
  /* width: auto; */
  width: 300px;
  height: 300px;
  transition: width 0.1s ease;
}

.s1-card-active .s1-card-img img {
  width: auto;
  height: 300px;
  /* max-width: 100%; */
}

@media (max-width: 1500px) {
  .s1-card-active .s1-card-img img {
    height: 200px;
  }
}

@media (max-width: 1300px) {
  .s1-card-active .s1-card-img img {
    height: 150px;
  }

  .s1-card-text p {
    font-size: 1rem;
  }
}

.section-bg1 {
  width: 1000px;
  height: 500px;
  position: absolute;
  top: 0;
  left: -5rem;
  /* background-image: url("/public/imgs/index/images/index-bg1_02.png"); */
  background-size: cover;
  background-position: center;
  z-index: -1;
}

.section-bg2 {
  width: 800px;
  height: 400px;
  top: 55%;
  right: 0rem;
  position: absolute;
  /* background-image: url("/public/imgs/index/images/indexbg2_03.png"); */
  background-size: cover;
  background-position: center;
  z-index: -1;
}

.product-content {
  width: 95%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}

.product-item {
  width: 380px;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 3rem;
  margin-bottom: 2rem;
  background-color: #ffffff;
  border-radius: 35px;
  padding: 2rem 0 0;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease;
}

/* .product-item:hover {
  transform: translateY(-px);
} */
.product-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top,
      #0271c1 0%,
      rgba(255, 255, 255, 0.75) 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 1;
  pointer-events: none;
}

.product-item:hover::before {
  opacity: 1;
}

.product-item img,
.product-item-text {
  position: relative;
  z-index: 2;
  transition: transform 0.3s ease, color 0.3s ease, background-color 0.1s ease;
}

.explore-more-btn {
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  background: transparent;
  color: #ffffff;
  border: 1px solid #ffffff;
  padding: 10px 28px;
  font-size: 1rem;
  line-height: 24px;
  height: 46px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 25px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.product-item:hover .explore-more-btn {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(-8px);
}

.product-item:hover .product-item-text {
  transform: translateY(-60px);
  color: #ffffff;
  background-color: transparent;
}

.product-item .explore-more-btn {
  position: absolute;
  bottom: 2rem;
  left: 50%;
  height: 40px;
  transform: translateX(-50%);
  background: transparent;
  color: #ffffff;
  border: 1px solid #ffffff;
  padding: 10px 28px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: 25px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 2;
}

@media (max-width: 1575px) {
  .product-item .explore-more-btn {
    font-size: 0.9rem;
    padding: 8px 15px;
  }
}

@media (max-width: 1270px) {
  .product-item .explore-more-btn {
    font-size: 0.9rem;
    padding: 8px 10px;
  }
}

.product-item:hover .explore-more-btn {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(-8px);
}

.product-item img {
  /* width: 200px; */
  height: 185px;
  object-fit: cover;
}

@media (max-width: 1575px) {
  .product-item img {
    height: 155px;
  }
}

@media (max-width: 1250px) {
  .product-item img {
    height: 145px;
  }
}

.arrow-white {
  background-color: transparent;
  color: #ffffff;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffffff;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.arrow-white svg {
  width: 16px;
  height: 16px;
  stroke: #ffffff;
}

.explore-more-btn:hover .arrow-white {
  transform: translateX(4px);
}

.product-item-text {
  border-radius: 0 0 35px 35px;
  padding: 2rem 0 1.5rem;
  text-align: center;
  width: 100%;
  background-color: #f1f1f1;
}

.product-item-text h3 {
  font-size: 1.5rem;
  font-weight: 400;
  /* margin-bottom: 1rem; */
}

.product-item-text p {
  font-size: 1.1rem;
  line-height: 1.5;
}

@media (max-width: 1300px) {
  .product-item-text h3 {
    font-size: 1.4rem;
  }

  .product-item-text p {
    font-size: 0.95rem;
  }
}

.banner {
  height: 99vh;
  position: relative;
  overflow: hidden;
}

.banner-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.banner-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-text {
  position: absolute;
  top: 33%;
  left: 13%;
  /* top: 50%;
  left: 35%;
  transform: translate(-50%, -50%); */
  color: #ffffff;
  font-size: 1.9rem;
  z-index: 2;
}

.banner-text h1 {
  letter-spacing: 0.2rem;
  margin-bottom: 1rem;
}

.banner-text p {
  font-size: 2.5rem;
}

.explore-btn {
  background-color: #ffffff;
  color: #0078ca;
  border: none;
  padding: 12px 35px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: 25px;
  display: inline-flex;
  align-items: center;
  gap: 15px;
  transition: all 0.3s ease;
  margin-top: 1rem;
}

.explore-btn2 {
  background-color: #0078ca;
  color: #ffffff;
  border: none;
  padding: 12px 35px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: 25px;
  display: inline-flex;
  align-items: center;
  gap: 15px;
  transition: all 0.3s ease;
  margin-top: 1rem;
}

.explore-btn:hover {
  background-color: #f0f8ff;
  transform: translateX(4px);
}

.explore-btn .arrow {
  background-color: #0078ca;
  color: #ffffff;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.explore-btn2 .arrow2 {
  background-color: #ffffff;
  color: #0078ca;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.explore-btn .arrow svg {
  width: 16px;
  height: 16px;
}

.explore-btn .arrow2 svg {
  width: 16px;
  height: 16px;
}

.explore-btn:hover .arrow {
  transform: translateX(4px);
}

.explore-btn:hover .arrow2 {
  transform: translateX(4px);
}

.arrow-btn {
  position: absolute;
  top: 90%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  border: none;
  font-size: 3rem;
  width: 50px;
  height: 50px;
  line-height: 50px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 3;
  transition: background 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.arrow-btn:hover {
  background: rgba(0, 0, 0, 0.6);
}

.arrow-btn.left {
  /* left: 20px; */
  left: 80%;
  background: #fff;
  color: #0078ca;
}

@media (max-width: 1500px) {
  .arrow-btn.left {
    left: 78%;
  }
}

.arrow-btn.right {
  /* right: 20px; */
  right: 13%;
  background: linear-gradient(135deg, #015b97, #5eb6f0);
  color: #fff;
}

.dots {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 3;
}

.dots span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background 0.3s;
}

.dots span.active {
  background: #fff;
}

.progress-circle {
  position: absolute;
  left: 10%;
  bottom: 5%;
  z-index: 3;
}

.progress-bg {
  opacity: 0.3;
}

.progress-bar {
  transition: stroke-dashoffset 0.1s linear;
}

@media (max-width: 768px) {
  section {
    width: 100%;
    height: auto;
  }

  .section-title h2 {
    font-size: 1.5rem;
  }

  .section1-content,
  .product-content {
    flex-direction: column;
    gap: 0.5rem;
  }

  /* section1 移动端优化 */
  .section1-content {
    gap: 1rem;
  }

  .s1-card {
    width: 90%;
    height: auto;
    border-radius: 20px;
    flex-direction: column;
    padding: 1rem;
  }

  .s1-card-active {
    width: 90%;
    border-radius: 20px;
  }

  .s1-card-text {
    width: 100%;
    padding: 1rem 0;
    opacity: 1;
  }

  .s1-card-text h3 {
    font-size: 1.1rem;
  }

  .s1-card-text p {
    min-height: 150px;
    font-size: 1rem;
    margin: 1rem 0;
  }

  .s1-card-img img {
    width: 100%;
    height: auto;
    margin-top: 0.5rem;
  }

  .s1-card-active .s1-card-img img {
    width: 100%;
    height: auto;
    margin-top: 0.5rem;
  }

  .s1-card .explore-btn,
  .s1-card a {
    display: none;
  }

  .banner {
    position: relative;
    height: auto;
    max-height: 50vh;
    overflow: hidden;
  }

  .banner-item {
    position: relative;
    width: 100%;
    height: auto;
  }

  .banner-item img {
    width: 100%;
    height: auto;
    max-height: 50vh;
    object-fit: cover;
  }

  .banner-text {
    position: absolute;
    left: 1rem;
    bottom: 2rem;
    transform: none;
    text-align: left;
    max-width: 90%;
  }

  .banner-text h1 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .banner-text p {
    font-size: 1rem;
    margin-bottom: 1rem;
  }

  .explore-btn {
    font-size: 0.9rem;
    padding: 0.5rem 1rem;

    display: none;
  }

  .arrow-btn {
    position: absolute;
    top: auto;
    bottom: 1rem;
    width: 2.5rem;
    height: 2.5rem;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .arrow-btn.left {
    left: 1rem;
  }

  .arrow-btn.right {
    right: 1rem;
  }

  .progress-circle {
    display: none;
  }
}

@media (max-width: 480px) {
  .section-title h2 {
    font-size: 1.3rem;
  }

  .section-desc {
    font-size: 0.95rem;
    margin: 0.5rem auto 2rem;
  }

  .s1-card-text h3 {
    font-size: 1rem;
  }

  .s1-card-text p {
    font-size: 0.95rem;
  }
}
</style>

<style scoped>
.section1-content-mobile {
  display: none;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {

  /* 全局容器 */
  section {
    height: auto !important;
    /* min-height: 100vh; */
  }

  /* 隐藏PC端section1-content */
  .section1 .section1-content {
    display: none;
  }

  /* 移动端轮播容器 */
  .section1-content-mobile {
    display: block;
    position: relative;
    overflow: hidden;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
  }

  .swiper-wrapper-mobile {
    display: flex;
    width: 100%;
    transition: transform 0.4s ease;
  }

  .s1-card-mobile {
    flex: 0 0 100vw;
    box-sizing: border-box;
    padding: 0 1rem;
  }

  /* 指示点 */
  .swiper-dots-mobile {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    margin-top: 1rem;
  }

  .swiper-dots-mobile span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ccc;
    cursor: pointer;
  }

  .swiper-dots-mobile span.active {
    background: #0057ff;
  }

  /* 左右箭头 */
  .swiper-arrow-mobile {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
    border: none;
    border-radius: 50%;
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .swiper-arrow-mobile.left {
    left: 0.5rem;
  }

  .swiper-arrow-mobile.right {
    right: 0.5rem;
  }

  /* banner */
  .banner {
    height: auto;
  }

  .banner-item img {
    height: auto;
    max-height: 50vh;
    object-fit: cover;
  }

  .banner-text {
    left: 1rem;
    bottom: 2rem;
  }

  .banner-text h1 {
    font-size: 1.5rem;
  }

  .banner-text p {
    font-size: 1rem;
  }

  .arrow-btn {
    width: 2.5rem;
    height: 2.5rem;
  }

  .progress-circle {
    width: 3rem;
    height: 3rem;
  }

  .progress-circle svg {
    width: 100%;
    height: 100%;
  }

  /* section1 */
  .section1-content {
    flex-direction: column;
    gap: 1.5rem;
  }

  .s1-card {
    flex-direction: column;
    height: auto;
  }

  .s1-card-img img {
    height: auto;
    width: 100%;
  }

  .explore-btn2 {
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
  }

  /* section3 */
  .step-box {
    width: 105%;
  }

  .step-container {
    /* flex-wrap: wrap; */
    /* gap: 0.5rem; */
  }

  .step-item {
    width: auto;
    padding: 0.5rem 0.5rem;
    font-size: 0.9rem;
  }

  .step-item2 {
    padding: 6px 19px;
    font-size: 14px;
    top: -5rem;
  }

  .s3-list ul li {
    /* flex-direction: column; */
    align-items: flex-start;
    gap: 0.5rem;
  }

  .s3-img img {
    max-width: 150px;
    height: auto;
    /* margin: 0 auto; */
  }

  /* section4 */
  .section4 {
    width: 80%;
    height: auto;
    padding: 2rem 1rem;
  }

  .s4top-box {
    flex-direction: column;
    gap: 1rem;
  }

  .news-btns {
    flex-wrap: wrap;
    justify-content: center;
  }

  .news-item {
    width: auto;
    font-size: 0.9rem;
    padding: 0.4rem 0.8rem;
  }

  .news-content-text1 {
    top: 70%;
  }

  .news-content-text1>h3 {
    font-size: 1.3rem;
  }

  .news-card,
  .news-card2 {
    width: 100% !important;
    height: auto;
  }

  .news-content>div {
    width: 100%;
    height: 300px;
    border-radius: 0px;
  }

  .news-card2 img {
    width: 100%;
    height: auto;
  }

  .news-date2 {
    margin-bottom: 0;
  }

  .section5 img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
  }

  .section6 {
    padding-top: 4rem;
  }

  .section6 img {
    width: 90%;
    height: auto;
  }

  /* 标题 */
  .section-title h2,
  .section-title2 h2,
  .section-title3 h2 {
    font-size: 1.5rem;
  }
}

@media (max-width: 768px) {
  .section-container {
    width: 90%;
    padding: 1rem;
  }

  .section-title h2 {
    font-size: 1.5rem;
  }

  .section1-content {
    flex-direction: column;
    gap: 0.5rem;
  }

  /* section1 移动端优化 */
  .section1-content {
    gap: 1rem;
  }

  .s1-card {
    width: 90%;
    height: auto;
    border-radius: 20px;
    flex-direction: column;
    padding: 1rem;
  }

  .s1-card-active {
    width: 90%;
    border-radius: 20px;
  }

  .s1-card-text {
    width: 100%;
    padding: 1rem 0;
    opacity: 1;
  }

  .s1-card-text h3 {
    font-size: 1.1rem;
  }

  .s1-card-img img {
    width: 100%;
    height: auto;
    margin-top: 0.5rem;
  }

  .s1-card .explore-btn,
  .s1-card a {
    display: none;
  }

  .banner {
    position: relative;
    height: auto;
    max-height: 50vh;
    overflow: hidden;
  }

  .banner-item {
    position: relative;
    width: 100%;
    height: auto;
  }

  .banner-item img {
    width: 100%;
    height: auto;
    max-height: 50vh;
    object-fit: cover;
  }

  .banner-text {
    position: absolute;
    left: 1rem;
    bottom: 2rem;
    transform: none;
    text-align: left;
    max-width: 90%;
  }

  .banner-text h1 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .banner-text p {
    font-size: 1rem;
    margin-bottom: 1rem;
  }

  .arrow-btn {
    position: absolute;
    top: auto;
    bottom: 1rem;
    width: 2.5rem;
    height: 2.5rem;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .arrow-btn.left {
    left: 1rem;
  }

  .arrow-btn.right {
    right: 1rem;
  }

  .progress-circle {
    display: none;
  }
}

/* 只在移动端显示 */
@media (min-width: 768px) {
  .back-to-top {
    display: none;
  }
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  /* 全局容器 */

  section {
    height: auto !important;
    /* min-height: 100vh; */
    /* height: auto; */
    padding: 0rem;
  }

  /* banner */
  .banner {
    height: auto;
  }

  .banner-item img {
    height: auto;
    max-height: 50vh;
    object-fit: cover;
  }

  .banner-text {
    left: 1rem;
    bottom: 2rem;
  }

  .banner-text h1 {
    font-size: 1.5rem;
  }

  .banner-text p {
    font-size: 1rem;
  }

  .arrow-btn {
    width: 2.5rem;
    height: 2.5rem;
  }

  .progress-circle {
    width: 3rem;
    height: 3rem;
  }

  .progress-circle svg {
    width: 100%;
    height: 100%;
  }

  /* section1 */
  .section-bg1 {
    display: none;
  }

  .section1-content {
    flex-direction: column;
    gap: 1.5rem;
  }

  .s1-card {
    flex-direction: column;
    height: auto;
  }

  .s1-card-img img {
    height: auto;
    width: 100%;
  }

  .explore-btn2 {
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
  }

  .product-content {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    gap: 12px;
    padding: 0 16px;
    -webkit-overflow-scrolling: touch;
    flex-direction: row;
    justify-content: space-between;
  }

  .product-item {
    width: auto;
    height: auto;
    flex: 0 0 32vw;
    scroll-snap-align: start;
    max-width: none;
    margin: 0;
    box-shadow: none;
    gap: 0.5rem;
    border-radius: 25px;
  }

  .product-item img {
    height: 66px;
  }

  .product-item h3 {
    font-size: 0.8rem;
  }

  .product-item-text p {
    font-size: 0.5rem;
  }

  .product-item-text {
    border-radius: 0;
    padding: 1rem 0 1.5rem;
  }

  .explore-more-btn {
    display: none;
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
  }

  /* section4 */
  .section4 {
    width: 90%;
    height: auto;
    padding: 2rem 1rem;
  }

  .s4top-box {
    flex-direction: column;
    gap: 1rem;
  }

  .news-btns {
    flex-wrap: wrap;
    justify-content: center;
  }

  .news-item {
    width: auto;
    font-size: 0.9rem;
    padding: 0.4rem 0.8rem;
  }

  .news-content {
    gap: 0.5rem;
    /* padding: 0 0.5rem; */
  }

  .news-card,
  .news-card2 {
    width: 100% !important;
    height: auto;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .news-card {
    min-height: 280px;
    background-size: cover;
    background-position: center;
    position: relative;
  }

  .news-card2 {
    display: flex;
    flex-direction: column;
    background: #fff;
    gap: 0;
  }

  .news-card2 img {
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 16px 16px 0 0;
  }

  .news-card2::before {
    display: none;
  }

  .news-card:active,
  .news-card2:active {
    transform: scale(0.98);
  }

  .news-content-text1 {
    position: absolute;
    top: auto;
    bottom: 1.5rem;
    left: 1.5rem;
    right: 1.5rem;
    transform: none;
    background: rgba(0, 0, 0, 0.6);
    padding: 1rem;
    border-radius: 12px;
    backdrop-filter: blur(4px);
  }

  .news-content-text1 h3 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    line-height: 1.4;
  }

  .news-content-text1 p {
    font-size: 0.95rem;
    opacity: 0.9;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .news-date1 {
    position: absolute;
    top: 1.5rem;
    left: 1.5rem;
    font-size: 1.1rem;
    background: rgba(255, 255, 255, 0.9);
    color: #333;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-weight: 500;
  }

  .news-date1 span {
    font-size: 1.3rem;
    font-weight: 600;
    color: #0078ca;
  }

  .news-content-text2 {
    padding: 0.5rem;
  }

  .news-content-text2 h3 {
    font-size: 0.9rem;
    margin-bottom: 0.8rem;
    line-height: 1.4;
    font-weight: 500;
  }

  .news-content-text2 p {
    font-size: 0.95rem;
    color: #666;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.5;
  }

  .news-date2 {
    font-size: 1rem;
    margin-bottom: 0.8rem;
    color: #0078ca;
    font-weight: 500;
  }

  .news-date2 span {
    font-size: 1.2rem;
    font-weight: 600;
  }

  .news-content-btn {
    display: none;
  }

  /* section5/6 */
  .section5,
  .section6 {
    height: auto;
    /* padding: 3rem 1rem; */
  }

  .section5 img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
  }

  .section6 img {
    width: 90%;
    height: auto;
  }

  /* 蜂巢合作伙伴区域移动端适配 */
  .fengc {
    width: 85%;
    display: flex;
    flex-wrap: wrap;
    height: 350px;
    /* overflow: hidden; */
    justify-content: center;
    gap: 0.5rem;
    padding: 1rem 0;
    /* margin: 0px auto; */
    margin: 0 1rem 0 2.7rem;
  }

  .hex-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.5rem;
    /* width: 100%; */
  }

  .hex-item {
    width: 18vw;
    height: 18vw;
    max-width: 45px;
    max-height: 45px;
    flex-shrink: 0;
  }

  .hex-item img {
    width: 55%;
    height: 100%;
    object-fit: contain;
  }

  .hex-center {
    width: 115%;
    height: 41vw;
    margin: 6.5rem auto;
  }

  .hex-center-text span {
    font-size: clamp(1rem, 4vw, 1.5rem);
  }

  .hex-center-text p {
    font-size: clamp(0.5rem, 2.4vw, 1rem);
  }

  .hex-grid1 {
    display: none;
  }

  .hex-grid2 {
    top: 57%;
    left: 0%;
  }

  .hex-grid3 {
    top: 57%;
    left: 11%;
  }

  .hex-grid4 {
    top: 57%;
    left: 22%;
  }

  .hex-grid5 {
    top: 57%;
    left: 33%;
  }

  .hex-grid6 {
    top: 57%;
    left: 45%;
  }

  .hex-grid7 {
    top: 57%;
    left: 57%;
  }

  .hex-grid8 {
    top: 57%;
    left: 69%;
  }

  /* 移动端回到顶部按钮 */
  .back-to-top {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #007bff;
    color: #fff;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 999;
    transition: opacity 0.3s;
  }

  .back-to-top:hover {
    opacity: 0.9;
  }

  .hex-grid9 {
    top: 57%;
    left: 80%;
  }

  .hex-grid10 {
    top: 57%;
    right: -3%;
  }

  /* 标题 */
  .section-title h2,
  .section-title2 h2,
  .section-title3 h2 {
    font-size: 1.5rem;
  }

  .title-shadow,
  .title-shadow2,
  .title-shadow3 {
    font-size: 2.3rem;
  }

  .section-desc {
    width: 100%;
    font-size: 1rem;
    margin: 1rem auto 2rem;
  }
}

/* 移动端展开按钮在PC端隐藏 */
@media (min-width: 768px) {
  .section1 .explore-btn[style*="display: block"] {
    display: none !important;
  }
}
</style>